import React from 'react'
import styles from './Main.module.scss'
import {sliderFirstData, allPartners} from './arrImages'
import { Link } from 'react-router-dom'
import Slider from 'react-slick/lib/slider'
import 'slick-carousel/slick/slick.scss'
import 'slick-carousel/slick/slick-theme.scss'
import './Slider/newSlider.css'
import { settings } from './Slider/sliderSettings'
import Gallery from './Gallery/Gallery'
import ProgressiveImage from '../../components/ProgressiveImage/ProgressiveImage'
import '../pages.css'

const Main = () => {
  return (
    <main className={styles.main} id="main">
      <div className={styles.mainImage}>
        <ProgressiveImage
          src="/images/mainImage.webp"
          width="1008"
          height="640"
          alt="Інтер’єр салону краси Нія"
          loading="eager"
          fetchPriority="high"
        />
      </div>
      <section className={styles.contentSection}>
        <div className={styles.headerSection}>
          <h2 className="sectionTitle">Наші послуги</h2>
          <p className={styles.sectionDescription}>Ми пропонуємо якісні послуги краси</p>
          <p className={styles.sectionButton}><Link to="/services">Переглянути всі послуги</Link></p>
        </div>
        <div className={styles.servicesWrapper}>
          <Slider {...settings}>
            {sliderFirstData.map((item)=>(
            <div className={styles.container} key={item.id}>
              <div className={styles.serviceImage}>
              <Link to={{ pathname: "/services", hash: item.hash}}>
                <ProgressiveImage
                  src={item.image}
                  width={item.width}
                  height={item.height}
                  alt={item.title}
                />
              </Link>
              </div>
              <h3 className={styles.serviceTitle}>
                {item.title}
              </h3>
              {/* <div className={styles.serviceDescription}>
                <p>{item.description}</p>
              </div> */}
            </div>
            ))}
          </Slider>
        </div>
      </section>
      <section className={styles.contentSection}>
        <div className={styles.headerSection}>
          <h2 className="sectionTitle">Галерея</h2>
          <p className={styles.sectionDescription}>Погляньте як все виглядає в нашому салоні</p>
        </div>
        <Gallery />
      </section>
      {/* <section className={styles.contentSection}>
        <div className={styles.headerSection}>
          <h2 className="sectionTitle">Новини нашого салону</h2>
          <p className={styles.sectionDescription}>Читайте про останні новини нашого салону!</p>
          <p className={styles.sectionButton}><a href="/">Всі новини</a></p>
        </div>
        <div className={styles.listOfNews}>
            {news.map((item) => (
              <article className={styles.article}>
                <div className={styles.articleImage}>
                  <a href='/'>
                    <img src={item.image} alt="" />
                  </a>
                </div>
                <h3 className={styles.articleTitle}>{item.description}</h3>
              </article>
            ))}
        </div>
      </section> */}
      <section className={styles.contentSection}>
        <div className={styles.headerSection}>
          <h2 className="sectionTitle">Партнери</h2>
          <p className={styles.sectionDescription}>Ми використовуємо лише високоякісну оригінальну продукцію.</p>
        </div>
        <div className={styles.listPartners}>
          <Slider {...settings}>
            {allPartners.map((item)=>(
              <div className={styles.partnerImage} key={item.id}>
                <img src={item.image} alt="Логотип партнера салону Нія" loading="lazy" decoding="async" />
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </main>
  )
}

export default Main
